// import React from 'react';
// import PageHeader from '../components/PageHeader';
// import './WhoWeAre.css';

// const stats = [
//   { num: '3+', label: 'Industries' },
//   { num: '50+', label: 'Team Members' },
//   { num: '12+', label: 'Countries Served' },
//   { num: '100%', label: 'Commitment' },
// ];

// const cards = [
//   {
//     title: 'Our Vision',
//     desc: 'To be a globally recognized enterprise that builds future-ready businesses through innovation, integrity, and impact.',
//     highlight: true,
//   },
//   {
//     title: 'Mission',
//     desc: 'Deliver excellence across industries through technology-driven solutions and sustainable practices.',
//     highlight: false,
//   },
//   {
//     title: 'Values',
//     desc: 'Integrity, Innovation, Excellence, Sustainability, and People-first approach in everything we do.',
//     highlight: false,
//   },
// ];

// const WhoWeAre: React.FC = () => {
//   return (
//     <>
//       <PageHeader
//         breadcrumb="Who we are"
//         title="Who We Are"
//         subtitle="A group of bold companies building the future across three industries."
//       />

//       <div className="who-grid">
//         {/* Left text */}
//         <div className="who-text">
//           <h1>Driven by Purpose,<br />Defined by Innovation</h1>
//           <p>
//             Ajera Group is a multi-industry enterprise building transformative businesses across
//             Agro Export, IT Solutions, and Construction. Our mission is to create sustainable
//             value through technology, quality, and people.
//           </p>
//           <p>
//             Founded with a vision to build future-ready enterprises, Ajera continuously adapts
//             to the evolving global landscape while staying true to its core values of integrity,
//             excellence, and impact.
//           </p>

//           <div className="stat-grid">
//             {stats.map((s) => (
//               <div className="stat-box" key={s.label}>
//                 <div className="stat-num">{s.num}</div>
//                 <div className="stat-label">{s.label}</div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right visual */}
//         <div className="who-visual">
//           {cards.map((c) => (
//             <div className={`who-card ${c.highlight ? 'highlight' : ''}`} key={c.title}>
//               <h3>{c.title}</h3>
//               <p>{c.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

import React from 'react';
import PageHeader from '../components/PageHeader';
import './WhoWeAre.css';

const stats = [
  { num: '3+', label: 'Industries' },
  { num: '50+', label: 'Team Members' },
  { num: '12+', label: 'Countries Served' },
  { num: '100%', label: 'Commitment' },
];

const cards = [
  {
    title: 'Our Vision',
    desc: 'To be a globally recognized enterprise that builds future-ready businesses through innovation, integrity, and impact.',
    highlight: true,
  },
  {
    title: 'Mission',
    desc: 'Deliver excellence across industries through technology-driven solutions and sustainable practices.',
    highlight: false,
  },
  {
    title: 'Values',
    desc: 'Integrity, Innovation, Excellence, Sustainability, and People-first approach in everything we do.',
    highlight: false,
  },
];

const WhoWeAre: React.FC = () => {
  return (
    <>
      <PageHeader
        breadcrumb="Who we are"
        title="Who We Are"
        subtitle="A group of bold companies building the future across three industries."
      />

      <div className="who-grid">
        <div className="who-text">
          <span className="who-eyebrow">Our Story</span>
          <h1>Driven by Purpose,<br />Defined by Innovation</h1>
          <p>
            Ajera Group is a multi-industry enterprise building transformative businesses across
            Agro Export, IT Solutions, and Construction. Our mission is to create sustainable
            value through technology, quality, and people.
          </p>
          <p>
            Founded with a vision to build future-ready enterprises, Ajera continuously adapts
            to the evolving global landscape while staying true to its core values of integrity,
            excellence, and impact.
          </p>
          <div className="stat-grid">
            {stats.map((s) => (
              <div className="stat-box" key={s.label}>
                <div className="stat-num">{s.num}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="who-visual">
          {cards.map((c) => (
            <div className={`who-card ${c.highlight ? 'highlight' : ''}`} key={c.title}>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WhoWeAre;